<template>
  <div>
    <div class="position-relative">
      <img class="img_style" :src="imgUrl" loading="lazy" alt>
      <img class="icon_style" src="/img/image/icon/ig_logo.png" @click="clickIcon" loading="lazy" alt="instagram">
    </div>
  </div>
</template>

<script>
import {isEmpty} from "../../util/helpers";

export default {
  name: "FollowUsItem",
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasSetting() {
      return !!this.settingData;
    },
    settingData() {
      return this.$store.getters.getSettingData;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    clickIcon() {
      window.open(this.instagramUrl, '_blank');
    }
  },
}
</script>

<style lang="scss" scoped>

.img_style {
  width: 100%;
  height: 100%;
  max-width: 285px;
  object-fit: cover;
  border-radius: 0;
  aspect-ratio: 1;
}

.icon_style {
  position: absolute;
  cursor: pointer;
  width: 50px;
  height: 50px;
  top: 10px;
  right: 10px;
}


@media (max-width: 576px) {
  .icon_style {
    width: 40px;
    height: 40px;
    top: 5px;
    right: 5px;
  }
}

</style>
